import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';

const InputSkeleton = () => (
  <Box p={2}>
    <Skeleton variant="text" width={100} />
    <Skeleton variant="text" height={50} />
  </Box>
);

export default InputSkeleton;
